import { Navigate } from '@sorare/routing';
import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_ESSENCE_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const EssencePage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_ESSENCE_TYPE, {
        params: {
          type: Rarity.limited,
        },
      })}
      replace
    />
  );
};
export default EssencePage;
